import React, { useState } from "react";
import { currencyUSD, currencyDecimal } from "../../../helpers/forms/formater";
import { AlertTriangle, Pencil, Save, Trash2 } from "lucide-react";
import { productsResource } from "../../../helpers/configRoutes/backend_helper";
import { Tooltip } from "react-tooltip";
import CustomSelect from "../../../components/form/CustomSelect";

const Columns = (addUpd, filters, setFilters, categories, rows, setRows, setItems, items) => {


    const asignCategory = (row, id) => {
        console.log(row)
        const exists = rows.find(r => r.id === row.id);

        if (exists) {
            // Si ya existe, actualiza el existente
            const updatedRows = rows.map(r =>
                r.id === row.id ? { ...r, category_id: id } : r
            );
            setRows(updatedRows);
        } else {
            // Si no existe, agrégalo al arreglo
            setRows([...rows, { ...row, category_id: id }]);
        }
    };

    const editItem = (item) => {
        console.log(item)
        const newArray = items.map((i) => {
            if (item.id === i.id) {
                return {
                    ...i,
                    product: {
                        ...i.product,
                        category_id: null,
                        category: {},
                    },
                    error: 'No existe categoria'
                };
            }
            return i;
        });
        setItems(newArray)
        const productsSnCategory = newArray
            .filter(pr => !pr.product?.category_id)
            .map(pr => pr.product);

        setRows(productsSnCategory);
    }

    let columns = [
        {
            id: "sku",
            name: "SKU",
            selector: (row) => `${row.product?.sku}`,
        },
        {
            id: "name",
            name: "Descripcion",
            selector: (row) => `${row.product?.name}`,
        },
        {
            id: "category",
            name: "Area",
            selector: row => (
                <div className="flex items-center gap-2 relative">
                    {row.product?.category?.name ?
                        <>
                            <span>{row.product.category.name}</span>
                            <button onClick={() => editItem(row)} className="text-blue-500 hover:text-blue-700">
                                <Pencil size={16} />
                            </button>
                        </>
                        :

                        <div className="min-w-[160px]">
                            <CustomSelect
                                className="text-sm"
                                holder="Area"
                                options={categories}
                                value={rows.find((r) => r.id == row.product.id)?.category_id}
                                handleChange={(e) => asignCategory(row.product, e.target.value)}
                            />
                        </div>


                    }

                    {(row.error && rows.find((r) => r.id == row.product?.id)?.category_id == null) && (
                        <div className="text-fr-danger" data-tooltip-id={`error-${row.id}`}>
                            <AlertTriangle size={16} />
                            <Tooltip id={`error-${row.product.id}`} place="top">
                                {row.error}. Clic para seleccionar  asignar area
                            </Tooltip>
                        </div>
                    )}

                    {(row.error && rows.find((r) => r.id === row.product?.id)?.category_id != null) && (
                        <div className="text-fr-success" data-tooltip-id={`error-${row.id}`}>
                            <AlertTriangle size={16} />
                            <Tooltip id={`error-${row.product.id}`} place="top">
                                {row.error}. Area asignada
                            </Tooltip>
                        </div>
                    )}
                </div>
            ),

        },

        {
            id: "unit_price",
            name: "Precio unitario",
            selector: (row) => (
                <span className="text-fr-accent font-semibold bg-fr-accent/10 px-3 py-1 rounded-full text-sm">
                    {currencyUSD(row.unit_price ?? 0)}
                </span>
            ),
        },
        {
            id: "units",
            name: "Unidades vendidas",
            selector: (row) => (
                <span className="text-fr-success font-semibold bg-fr-success/10 px-3 py-1 rounded-full text-sm">
                    {currencyDecimal(row.quantity ?? 0)}
                </span>
            ),
        },
        {
            id: "total",
            name: "Subtotal",
            selector: (row) => (
                <span className="text-fr-success font-semibold bg-fr-success/10 px-3 py-1 rounded-full text-sm">
                    {currencyUSD(row.quantity * row.unit_price)}
                </span>
            ),
        },
    ];
    return columns;
};

export default Columns;
